import { Component, OnInit, inject, signal } from '@angular/core';
import { ContactSupportService } from '../../services/contact-support.service';
import { IsgLoaderComponent } from '../../../fwcore/components/isg-loader/isg-loader.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-page-no-license',
  templateUrl: './page-no-license.component.html',
  styleUrls: ['./page-no-license.component.scss'],
  imports: [CommonModule, IsgLoaderComponent],
  standalone: true
})
export class PageNoLicenseComponent implements OnInit {
  public contactSupportService = inject(ContactSupportService);

  constructor() { }

  ngOnInit(): void {
  }

  contactSupport(): void {
    this.contactSupportService.open();
  }
 
}

